<template>
  <el-container class="height100">
    <el-header class="obpm-header-t" v-if="isAdmin">
      <admin_header />
    </el-header>
    <el-main v-show="showmode=='LIST'" class="mainHeight" ref="main">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav">
      <el-breadcrumb-item :to="{ path: '/home' }">{{$t('location')}}</el-breadcrumb-item>

        <el-breadcrumb-item :to="{ path: '/main' }">{{$t('enterprise_list')}}</el-breadcrumb-item>
      </el-breadcrumb>

      <el-divider></el-divider>
      <div class="obpm-fromContent-title obpm-enterpriseDomain-logo clearfix normalHeight">
        <el-col :span="12" class="normalLineH">{{$t('enterprise_list')}}</el-col>
        <el-col :span="12" class="obpm-oneBtn normalLineH height100" style="text-align:right">
          <el-button
            type="primary"
            class="obpm-btn obpm-btn-primary"
            id="new_domain_btn"
            title="新建域(租户)"
            onmouseover
            @click="onCreateBtnClick"
            size="small"
            v-if="!isStatusShow"
          >{{$t('new')}}</el-button>
        </el-col>
      </div>
      <el-form :inline="true" class="demo-form-inline" size="small"  @submit.native.prevent>
        <el-form-item >
          <el-input :placeholder="$t('enterprise_name')" v-model="searchdata.data.name" @keyup.enter.native="searchTableData"></el-input>
        </el-form-item>
        <el-form-item >
          <el-input type='text' :placeholder="$t('admin')" v-model="searchdata.data.username" @keyup.enter.native="searchTableData"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchTableData" plain size="mini">{{$t('query')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button  @click="resetDomainSearch" size="mini">{{$t('reset')}}</el-button>
        </el-form-item>
        <el-form-item  v-if="showListVisible">
          <el-button size="mini" plain type="danger" @click="delDomain">{{$t('del')}}</el-button>
        </el-form-item>
        <el-form-item  v-if="showListVisible">
          <el-button size="mini" plain @click="showListVisible = !showListVisible">{{$t('back')}}</el-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="12" v-if="!showListVisible">
        <el-col v-for="domain in domains.datas" :key="domain.id" :span="4">
          <el-card shadow="hover" class="domainList">
            <div class="domainLi">
              <el-row type="flex" class="row-bg" justify="end">
                <el-col :span="1" class="domainLiDel">
                  <i class="el-icon-close " @click="deleteDomain(domain.id)"></i>
                </el-col>
              </el-row>
              <router-link :to="{ name: 'domain', query: { domainid: domain.id, showLdapButton: showLdapButton}}" class="FontColor">
                <el-row>
                  <el-col :span="6">
                    <!-- <img src="../assets/images/logo.gif" class="domainLiImg"> -->
                    <div v-if="domain.logoUrl!=''">
                      <img :src="domain.logoUrl" class="domainLiImg" >
                    </div>
                    <div v-if="domain.logoUrl==''">
                      <img src="../assets/images/bcx/logo.gif" class="domainLiImgT">
                    </div>
                  </el-col>
                  <el-col :span="18" >
                    <p><span>{{showShortName(domain.name)}}</span><span class="domainLiStatus">{{domain.status == 1 ? '已激活' : '未激活'}}</span></p>
                    <p class="domainLiAdmin">
                      <span v-for="(elm,index) in domain.users" :key="index">{{elm.username}},</span>
                    </p>
                    <p>
                      <!-- <el-switch class="miniFontSize" v-model="domain.status" @change="changeStatus(domain)" :active-value="1" :inactive-value="0"></el-switch> -->
                    </p>

                  </el-col>
                </el-row>
              <!-- <router-link :to="{ name: 'domain', query: { domainid: domain.id}}">{{domain.name}}</router-link>
              <el-button type="text" icon="el-icon-delete" style="float:right;vertical-align:middle" @click="deleteDomain(domain.id)"></el-button> -->
              </router-link>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" v-if="domains.rowCount>10">
          <div class="adminListMore" @click="showList">
            <img src="../assets/images/Arrow.png" alt="" class="adminListMoreImg">
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="12" v-if="showListVisible">
        <el-table :data="domains.datas"
        ref="multipleTable"
        :row-key="handleReserve"
        @row-click="onRowClick"
        class="Trpointer"
        @selection-change="handleSelectionChange"
        header-cell-class-name="tableHeaderbg"
        :height="tableListConHeight"
        size="small">
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="name" :label="$t('enterprise_name')"></el-table-column>
        <el-table-column prop="users" :label="$t('admin')">
          <template slot-scope="scope">
            <span v-for="(elm,index) in scope.row.users" :key="index">
              {{elm.username}},
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('active')">
          <template slot-scope="scope">
            <span>{{scope.row.status==1?$t('active'):$t('inactive')}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="searchTableData"
        :current-page.sync="searchdata.currpage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchdata.pagelines"
        layout="prev, pager, next, total, sizes"
        background
        :total="domains.rowCount?domains.rowCount:0"
      ></el-pagination>
      </el-row>
    </el-main>
    <el-main v-show="showmode=='DETAIL'">
      <main_detail  @exit="onExit" v-if="showmode=='DETAIL'"/>
    </el-main>
  </el-container>
</template>

<script>
import admin_header from "@/components/admin_header.vue";
import main_detail from "@/components/main_detail.vue";

export default {
  components: {
    admin_header,
    main_detail,
  },
  mounted(){
    this.tableListConHeight=this.$refs.main.$el.getClientRects()[0].height - 185;
    
  },
  created() {
    this.url=this.$api.getDebugUrl(this.url);
    this.searchTableData();
  },
  computed:{
  },
  data() {
    return {
      domains: [],
      searchUserName:'',
      showmode:'LIST',
      url:"/assets/images/LOGO.png",
      content:{},
      multipleSelection:[],
      searchdata:{
        currpage: 1,
        pagelines: 10,
        data:{
          name:"",
          username:''
        }
      },
      showListVisible:false,
      isStatusShow:true,
      showLdapButton: false,
      tableListConHeight:0,
      isAdmin:this.$store.state.currentUser.type == 'admin'
    };
  },

  methods: {
    searchTableData(){
      this.$api.getDomains(this.searchdata, {
        onSucess: response => {
          this.domains = response.data.data;
          this.isStatusShow=response.data.data.newButtonShow;
          this.showLdapButton = response.data.data.showLdapButton;
        }
      });
    },
    showList(){
      this.showListVisible=true;
    },
    changeStatus(domain){
      this.content=domain;
      this.$api.updateDomain(domain.id, this.content, {
          onSucess: resp => {
            if (resp && resp.data.errcode == 0) {
              this.$message({
                showClose: true,
                message: "修改成功!",
                type: "success"
              });
            } else {
              this.$message({
                message: resp.data.errmsg,
                type: "error"
              });
            }
          }
        });
    },
    onCreateBtnClick(){
       this.showmode = 'DETAIL';
    },
    
    resetDomainSearch(){
      this.searchdata={
        currpage: 1,
        pagelines: 10,
        data:{
          name:"",
          username:''
        }
      };
      this.searchTableData();
    },
    
    onExit(){
      this.showmode = 'LIST';
      this.searchTableData();
    },

    deleteDomain(domainid){
      this.delDomains([domainid])
    },
    delDomain(){
      if(this.multipleSelection.length > 0){
        this.delDomains(this.multipleSelection)
      }else{
        this.$message.error('请选择要删除的域')
      }
    },
    delDomains(ids){
      this.$api.deleteDomain( ids,  {
        onSucess: resp => {
          if(resp.data.errcode==0){
            this.$message({
              showClose: true,
              message: resp.data.data,
              type: "success"
            });
            this.searchTableData();
          }else{
            this.$message({
              showClose: true,
              message:resp.data.errmsg,
              type: "error"
            });
          }
        },
        onError:(resp) => {
          this.$message({
            showClose: true,
            message: resp.data.errmsg,
            type: "error"
          });
        }
      });
    },
    handleSelectionChange(val){
      var arr = [];
      val.map((val) => {
        this.domains.datas.map((v) => {
          if(val.id == v.id){
            arr.push(val.id)
          }
        })
      })   
      this.multipleSelection = arr;
    },
    handleReserve(row){
      return row.id
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    onRowClick(row){
      this.$router.push({ name: 'domain', query: { domainid: row.id}})
    },
    // 显示短标题
    showShortName(txt){
      if(txt.length <= 6){
        return txt
      }else{
        return txt.slice(0, 6) + '...'
      }
    }
  }
};
</script>

<style>

.demo-form-inline{
  padding-top: 8px;
}
</style>